import React from 'react'
import { Paper, Text, Box, Input, Center, Image, Flex, Button } from '@mantine/core'
import { Dropzone } from '@mantine/dropzone'
import { useSupplierFormContext } from '../hook/supplier-form'
import { IconPhotoPlus } from '@tabler/icons-react'
import { notificationError } from '../../../ui/Notifications'

const FormLogoSupplier = () => {
  const form = useSupplierFormContext()

  const handleUploadImage = (file) => {
    const fileEncoded = file[0]
    const fileReader = new FileReader()
    fileReader.readAsDataURL(fileEncoded)
    fileReader.onload = (reader) => {
      form.setFieldValue('logo_encoded', reader.target.result)
    }
  }

  const handleErrorFile = (file) => {
    const fileState = Object.values(file)
    const errorMessage = fileState[0].errors[0].message
    if (errorMessage) {
      notificationError('Upload Logo Supplier Error', `${errorMessage}`)
    }
  }

  const mappingResultLogo = (logoEncoded) => {
    if (logoEncoded === null) {
      return (
        <Input.Wrapper label='Upload Logo Supplier' size='xs'>
          <Box>
            <Dropzone
              h={200}
              accept={[
                'image/png',
                'image/jpeg',
                'image/jpg',
              ]}
              onDrop={(files) => handleUploadImage(files)}
              onReject={(files) => handleErrorFile(files)}
              maxSize={2000000}
            >
              <Box ta='center' my={40}>
                <Center h={40}>
                  <IconPhotoPlus size={24} color='gray' />
                </Center>
                <Box>
                  <Text fz={12} c='blue.9'>Upload Logo Here</Text>
                  <Text fz={12} c='gray.6'>PNG, JPG, JPEG up to 2 MB</Text>
                </Box>
              </Box>
            </Dropzone>
          </Box>
        </Input.Wrapper>
      )
    } else {
      return (
        <Box my={10}>
          <Text fz={12} my={5} fw='500'>Preview Logo Supplier</Text>
          <Center h={200} w='auto' pos='relative' my={8} style={{ backgroundColor: '#f8f9fa', border: '1px dashed #ced4da' }}>
            <Paper >
              <Image src={logoEncoded} w='auto' radius='md' h={200} fit='cover' />
            </Paper>
          </Center>
          <Flex justify='end' my={10}>
            <Button size='compact-xs' onClick={() => form.setFieldValue('logo_encoded', null)}>Remove Logo</Button>
          </Flex>
        </Box>
      )
    }
  }

  return (
    <Paper shadow="xs" radius="md" withBorder p="sm" mb='md'>
      <Text fz={14} fw='bold' mb='sm'>Supplier Logo</Text>
      <Box my={10}>
        {mappingResultLogo(form.getValues().logo_encoded)}
      </Box>
    </Paper>
  )
}

export default FormLogoSupplier